<template>
  <div class="organazation">
    <header>
      <topbar />
      <navbar v-show="isMobile !== true" />
      <mobile-nav v-show="isMobile" />
      <section-header text="organazationChart" />
    </header>
    <main>
      <b-container>
        <b-row>
          <b-col sm="12">
            <div class="image-container">
              <img src="../../assets/images/organazation.jpeg" alt="" />
              <!-- <img
                src="../../assets/images/blog-post-header.jpg"
                alt=""
                v-else
              /> -->
            </div>
          </b-col>
        </b-row>
      </b-container>
      <section class="section-deps">
        <b-container>
          <section class="section section-links">
            <h3>{{ $t("Additionallinks") }}</h3>
            <ul class="links">
              <li>
                <router-link
                  :to="{ name: 'agreements'}"
                >
                  {{ $t("agreements") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'fundation'}"
                >
                  {{ $t("foundation") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'management'}"
                >
                  {{ $t("Collegeadministration") }}
                </router-link>
              </li>
              <li>
                <router-link
                  :to="{ name: 'calender'}"
                >
                  {{ $t("aboutUs.about17") }}
                </router-link>
              </li>
            </ul>
          </section>
        </b-container>
      </section>
    </main>
    <footer>
      <footer-component />
    </footer>
  </div>
</template>

<script>
// import { filesUrl } from "@/main";
import MobileNav from "@/components/layout/MobileNav.component.vue";
import Topbar from "@/components/layout/Topbar.component.vue";
import Navbar from "@/components/layout/Navbar.component.vue";
import SectionHeader from "@/components/layout/SectionHeader.component.vue";
import FooterComponent from "@/components/layout/FooterComponent.component.vue";
export default {
  components: {
    Topbar,
    Navbar,
    SectionHeader,
    FooterComponent,
    MobileNav,
  },
  data() {
    return {
      isMobile: false,
      lang: "ar",
    };
  },
  mounted() {
    if(localStorage.getItem("lang")=="en"){
    document.title = ` Al-Nisour University   - Organazation Chart`;
    document.querySelector('meta[name="title"]').setAttribute("content","Organazation Chart");
    document.querySelector('meta[name="description"]').setAttribute("content", "");
    document.querySelector('meta[property="og:title"]').setAttribute("content","Organazation Chart");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "");
    }else{
    document.title = `جامعة النسور  - الهيكل التنظيمي`;
    document.querySelector('meta[name="title"]').setAttribute("content","الهيكل التنظيمي");
    document.querySelector('meta[name="description"]').setAttribute("content", "");
    document.querySelector('meta[property="og:title"]').setAttribute("content","الهيكل التنظيمي");
    document.querySelector('meta[property="og:description"]').setAttribute("content", "");
    }
    document.querySelector('meta[property="og:image"]').setAttribute("content", `https://e-learn.nuc.edu.iq/images/logo.png`);
    // document.getElementById("icon").setAttribute("href",`${filesUrl}favicon.ico`); 
    this.lang = localStorage.getItem("lang");
    if (window.innerWidth > 991) {
      this.isMobile = false;
    } else {
      this.isMobile = true;
    }
  },
};
</script>
